module.exports = __webpack_public_path__ + "static/media/youtube 1.96c82050.svg";